var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "icon" },
    [
      _vm.type === "inline"
        ? _vm._t("default")
        : _c("svg", [
            _c("use", {
              attrs: {
                "xlink:href":
                  _vm.assetsUrl + "icons/symbols.svg#icon-" + _vm.name,
              },
            }),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }